import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";

export function EventCard({ event, index = 0, large = false }) {
  const { addItem } = useCart();
  return (
    <motion.article
      data-testid={`event-card-item-${event.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden border border-white/10 bg-carbon ${large ? "min-h-[560px]" : "min-h-[440px]"}`}
    >
      <Link data-testid={`event-gallery-link-${event.slug}`} to={`/events/${event.slug}`} className="absolute inset-0">
        <img src={event.cover_url} alt={`${event.title} event photography`} className="h-full w-full object-cover opacity-75 transition duration-700 group-hover:scale-[1.045] group-hover:opacity-95" />
        <div className="absolute inset-0 bg-gradient-to-t from-onyx via-onyx/35 to-transparent" />
      </Link>
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
        <div className="mb-4 flex flex-wrap gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-titanium/80">
          <span className="flex items-center gap-2"><CalendarDays className="h-3 w-3" />{event.date}</span>
          <span className="flex items-center gap-2"><MapPin className="h-3 w-3" />{event.location}</span>
        </div>
        <h3 className={`font-display font-light text-white ${large ? "text-4xl sm:text-5xl" : "text-3xl"}`}>{event.title}</h3>
        <p className="mt-3 max-w-xl text-sm leading-6 text-zinc-400">{event.description}</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <Link data-testid={`view-event-button-${event.slug}`} to={`/events/${event.slug}`} className="inline-flex items-center gap-2 border border-gold/40 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-gold transition-colors hover:bg-gold hover:text-onyx">
            View gallery <ArrowRight className="h-3 w-3" />
          </Link>
          <button data-testid={`buy-album-button-${event.slug}`} onClick={() => addItem({ item_type: "album", item_id: event.id, title: event.title, price: event.album_price })} className="inline-flex items-center gap-2 bg-white/10 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-white backdrop-blur transition-colors hover:bg-white hover:text-onyx">
            Album ${Number(event.album_price).toFixed(0)}
          </button>
        </div>
      </div>
    </motion.article>
  );
}
